import axios from "axios"


export {statusReasonActions};

axios.defaults.withCredentials = true;

function statusReasonActions () {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getStatusReasons,
    getByCodeStatusReasons,
    exportDataStatusReason,
    createStatusReason,
    deleteStatusReason,
    editStatusReason
  }


  async function exportDataStatusReason(tenant:string|undefined) {
    const exportAllDataStatusReason = await axios.get(
      `${baseUrl}/masterdatavehicle/statusreason/excel`,
      {
        params:{tenant:tenant},
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportAllDataStatusReason;
  }

async function getStatusReasons(tenant:string|undefined, pageNumber: number, pageSize: number){
  const getAllStatusReasons = await axios.get(`${baseUrl}/masterdatavehicle/statusreason`,
  { params: {tenant:tenant, pageNumber: pageNumber, pageSize: pageSize} }
)

  return getAllStatusReasons
}

async function getByCodeStatusReasons(tenant:string|undefined,code: any){
  const getSelectedByCodeStatusReasons = await axios.get(`${baseUrl}/masterdatavehicle/statusreason/code/${code}`,{params:{tenant:tenant}})
         return getSelectedByCodeStatusReasons;
  
}


async function createStatusReason(tenant:string|undefined,createStatusReasonObject:any) {
  const createNewStatusReason = await axios.post(`${baseUrl}/masterdatavehicle/statusreason`, createStatusReasonObject,{params:{tenant:tenant}});
  return createNewStatusReason;

}

async function deleteStatusReason(tenant:string|undefined,id:any) {
  const deleteSelectedStatusReason = await axios.delete(`${baseUrl}/masterdatavehicle/statusreason/${id}`,{params:{tenant:tenant}});
  return deleteSelectedStatusReason;

}

async function editStatusReason(tenant:string|undefined,id:any,editStatusReasonObject: any) {
  const editSelectedStatusReason = await axios.put(`${baseUrl}/masterdatavehicle/statusreason/${id}`, editStatusReasonObject,{params:{tenant:tenant}});
  return editSelectedStatusReason;
}


}
